export const HIDE_SOC_SINCE_SIGNUP_MS = 24 * 60 * 60 * 1000; // 24 hours
